/* ==========================================================================
   BOSSVI · Regalo de Navidad: cascada de luces (19 oct 2026, «BOSSVI · Navidad 2»)
   --------------------------------------------------------------------------
   Va con snippets/bossvi-regalo.liquid. Se carga en todas las páginas
   (snippets/bossvi-global.liquid), porque la cesta lateral está en todas y se
   puede comprar un abeto desde la ficha o desde la compra rápida.

   1 · CESTA. Por cada abeto de las medidas REGALAN que haya en la cesta, entra
       una cascada LU-8202800 marcada con la propiedad oculta _bv_regalo. Si
       quitan el abeto, se va la cascada. Quien pone la cascada a 0 € es el
       descuento automático «Regalo de Navidad · cascada de luces»
       (DiscountAutomaticNode/2426944749955), que regala 1 cascada por abeto
       y no tiene tope por pedido.
       22 oct (Laia): TAMBIÉN se regala 1 cascada en cualquier pedido de 300 € o
       más, lleve lo que lleve. Cuenta el importe de la cesta sin la cascada de
       regalo, sin tarjetas regalo ni packs de acabado. Con un abeto que regala
       y además 300 €, no se suman: 1 cascada por abeto, o 1 si no hay abeto.
       La pone a 0 € el descuento «Regalo de Navidad · luces en pedidos desde
       300 €» (DiscountAutomaticNode/2428882551171).
       25 oct (Héctor): ESCALERA para subir el ticket medio.
         · De 300 a 449,99 €: la de 150 cm de regalo y, en la cesta, el botón
           «Pásate a la de 200 cm por 19,90 €» (descuento «Mejora de luces…»,
           66,98 € menos sobre LU-8206100). Se puede deshacer.
         · Desde 450 €: la de 200 cm de regalo en vez de la de 150 (descuento
           «Regalo de Navidad · cascada de 200 cm en pedidos desde 450 €»).
         Los tres descuentos usan la colección interna «Descuentos · regalo de
         luces (sin cascada)»: la cascada que se compre aparte no cuenta para
         llegar a los 300 o 450 €, y aquí tampoco.
         Los avisos de la cesta («te faltan…», el botón de la mejora) los pinta
         snippets/bossvi-regalo.liquid, parte «aviso».
       Seguridad: si dentro de fechas la cascada NO sale gratis (el descuento
       está pausado o se ha cambiado), se saca de la cesta y no se vuelve a
       meter en esa sesión. Nunca se cobra una cascada que dijimos que era regalo.
   2 · FICHA. Pone en <html data-bv-var> la medida elegida para que el CSS del
       snippet enseñe el recuadro, la cinta y la segunda línea del botón solo
       con las medidas que regalan.

   Fechas: del 24 oct 2026 00:00 (adelantado desde el 3 nov el 22 oct) al 6 ene 2027 23:59 (Madrid). Prueba antes de
   fecha: ?bv_regalo=prueba (se quita con ?bv_regalo=off).
   Medición: Shopify.analytics.publish('bv_regalo_ver') al enseñar el recuadro
   y ('bv_regalo_cesta') al meter la cascada en la cesta.
   3 · PIEZA PROPUESTA (26 oct, «BOSSVI · Ticket medio»). Cuando falta poco
       para 300 o 450 €, la tarjeta de la cesta propone una pieza para vestir
       lo que ya hay (p. ej. 6 bolas de terciopelo) con el botón data-bv-pack
       (reglas en snippets/bossvi-regalo.liquid, parte «aviso»). Aquí: añadirla
       con la propiedad oculta _origen = aviso:<300|450>, repintar la cesta y
       dejar que ordenar() ponga la cascada que toque. Medición: bv_pack_ver
       (la tarjeta se ve en pantalla, una vez por pieza) y bv_pack_anadir.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__bvRegalo) return;
  window.__bvRegalo = true;

  /* Las mismas 4 medidas que el descuento y que el metacampo bossvi.regalo_luces */
  var REGALAN = {
    '62852240048515': 'N.-4526600',
    '62852256104835': 'N.-3318101',
    '62852256137603': 'N.-3324001',
    '62852262527363': 'N.-5065401'
  };
  var CASCADA = 62916168352131; /* LU-8202800 · 150 cm */
  var REF = 'LU-8202800';
  var CASCADA200 = 62916201218435; /* LU-8206100 · 200 cm */
  var REF200 = 'LU-8206100';
  var PRECIO_MEJORA = 1990; /* lo que paga el cliente por la de 200 cm entre 300 y 450 € */
  var GRANDE = 45000;      /* desde 450 €, la de 200 cm de regalo */
  var INICIO = 1792792800000; /* 2026-10-24 00:00 Madrid */
  var FIN = 1799276399000;    /* 2027-01-06 23:59:59 Madrid */
  var FUENTE = 'bossvi-regalo';
  var MINIMO = 30000; /* 300,00 € en céntimos (Laia, 22 oct) */
  var NO_CUENTAN = { 'Tarjeta regalo': true, 'Acabado': true };

  function guardado(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function guardar(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }

  if (/[?&]bv_regalo=prueba(&|$)/.test(location.search)) guardar('bv-regalo-prueba', '1');
  if (/[?&]bv_regalo=off(&|$)/.test(location.search)) { guardar('bv-regalo-prueba', null); guardar('bv-regalo-parado', null); }
  function prueba() { return guardado('bv-regalo-prueba') === '1'; }
  function mejora() { return guardado('bv-regalo-mejora') === '1'; }
  function enFechas() { var n = Date.now(); return n >= INICIO && n <= FIN; }
  function activo() { return (enFechas() || prueba()) && guardado('bv-regalo-parado') !== '1'; }
  if (enFechas() || prueba()) document.documentElement.classList.add('bv-regalo-on');

  function medir(nombre, datos) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nombre, datos || {});
      }
    } catch (e) { /* la medición nunca rompe la compra */ }
  }

  /* ---------------------------------------------------------------- CESTA */
  function seccionesCesta() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      if (ids.indexOf(c.dataset.sectionId) === -1) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  function pedir(url, cuerpo) {
    var secs = seccionesCesta();
    if (cuerpo && secs.length) { cuerpo.sections = secs.join(','); cuerpo.sections_url = location.pathname; }
    return fetch(url, {
      method: cuerpo ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: cuerpo ? JSON.stringify(cuerpo) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'cesta');
        return j;
      });
    });
  }

  /* Avisa al tema (cesta lateral, página de la cesta, contador) igual que lo hace el pack de acabado */
  function avisar(resp) {
    var cuenta = null;
    if (resp && typeof resp.item_count === 'number') cuenta = resp.item_count;
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: resp,
        sourceId: FUENTE,
        data: { source: FUENTE, itemCount: cuenta, sections: resp ? resp.sections : undefined }
      }
    }));
  }

  var ocupado = false, otraVez = false, vueltas = 0;

  function ordenar() {
    if (ocupado) { otraVez = true; return; }
    ocupado = true;
    pedir('/cart.js').then(function (cesta) {
      var items = cesta.items || [];
      var arboles = 0, base = 0, r150 = [], r200 = [], t150 = 0, t200 = 0;
      items.forEach(function (it) {
        var regalo = it.properties && it.properties._bv_regalo;
        if (REGALAN[String(it.variant_id)]) arboles += it.quantity;
        if (it.variant_id === CASCADA || it.variant_id === CASCADA200) {
          if (regalo && it.variant_id === CASCADA) { r150.push(it); t150 += it.quantity; }
          if (regalo && it.variant_id === CASCADA200) { r200.push(it); t200 += it.quantity; }
          return; /* ninguna cascada cuenta para llegar a los 300 / 450 € */
        }
        if (!NO_CUENTAN[it.product_type]) base += it.final_line_price;
      });
      var total = Math.max(arboles, base >= MINIMO ? 1 : 0);
      /* 26 oct («Navidad 2»): con 2 abetos o más, todas de 150 cm (una por abeto). Shopify no deja que el descuento
         de los abetos y el de 450 € / la mejora usen los mismos abetos, y la de 150 se quedaba sin regalar. */
      var q200 = (total === 1 && (base >= GRANDE || (mejora() && base >= MINIMO))) ? 1 : 0;
      var q150 = total - q200;
      var motivo = base >= GRANDE ? 'pedido_450' : (q200 ? 'mejora' : (arboles > 0 ? 'abeto' : 'pedido_300'));
      if (!activo()) { q150 = 0; q200 = 0; }

      /* Todo cuadra: solo queda comprobar que cada cascada sale al precio prometido */
      if (q150 === t150 && q200 === t200 && r150.length <= 1 && r200.length <= 1) {
        if ((q150 + q200) > 0 && enFechas() && !prueba()) {
          var d150 = 0, p150 = 0, d200 = 0, p200 = 0;
          items.forEach(function (it) {
            if (it.variant_id === CASCADA) { d150 += it.original_line_price - it.final_line_price; p150 = it.original_price; }
            if (it.variant_id === CASCADA200) { d200 += it.original_line_price - it.final_line_price; p200 = it.original_price; }
          });
          var falla150 = q150 > 0 && d150 + 1 < q150 * p150;
          var falla200 = q200 > 0 && d200 + 1 < (base >= GRANDE ? p200 : p200 - PRECIO_MEJORA);
          if (falla150 || falla200) {
            /* un descuento no está haciendo su parte: fuera los regalos, y no se vuelven a meter en esta sesión */
            guardar('bv-regalo-parado', '1');
            var fuera = {};
            r150.concat(r200).forEach(function (it) { fuera[it.key] = 0; });
            return pedir('/cart/update.js', { updates: fuera }).then(avisar);
          }
        }
        return null;
      }

      if (vueltas++ > 4) return null; /* nunca en bucle */

      /* 1 · ajustar las líneas que ya están (una sola línea por tamaño) */
      var cambios = {}, hay = false, nuevos = [];
      function ajustar(lineas, q, id, ref) {
        if (lineas.length) {
          lineas.forEach(function (it, i) {
            var quiero = i === 0 ? q : 0;
            if (it.quantity !== quiero) { cambios[it.key] = quiero; hay = true; }
          });
        } else if (q > 0) {
          nuevos.push({ id: id, quantity: q, properties: { _bv_regalo: ref } });
        }
      }
      ajustar(r150, q150, CASCADA, REF);
      ajustar(r200, q200, CASCADA200, REF200);
      if (hay) {
        return pedir('/cart/update.js', { updates: cambios }).then(function (r) { avisar(r); return 'otra'; });
      }
      /* 2 · añadir las que faltan */
      if (nuevos.length) {
        return pedir('/cart/add.js', { items: nuevos }).then(function (r) {
          nuevos.forEach(function (n) { medir('bv_regalo_cesta', { cantidad: n.quantity, cascada: n.properties._bv_regalo, motivo: motivo }); });
          return pedir('/cart.js').then(function (c) { r.item_count = c.item_count; avisar(r); return 'otra'; });
        });
      }
      return null;
    }).catch(function () { /* si la cesta falla, no se toca nada */ })
      .then(function (siguiente) {
        ocupado = false;
        if (siguiente === 'otra' || otraVez) { otraVez = false; ordenar(); }
        else vueltas = 0;
      });
  }

  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data ? e.detail.data : {};
    if (d.source === FUENTE) return;
    if (d.didError) return;
    vueltas = 0;
    ordenar();
  });

  /* Botón de la cesta «Pásate a la de 200 cm» / «Volver a la de 150 cm» (parte «aviso» del snippet) */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bv-mejora]') : null;
    if (!b) return;
    e.preventDefault();
    var si = b.getAttribute('data-bv-mejora') === 'si';
    guardar('bv-regalo-mejora', si ? '1' : null);
    b.disabled = true;
    b.textContent = si ? 'Cambiando a la de 200 cm…' : 'Volviendo a la de 150 cm…';
    medir('bv_regalo_mejora', { accion: si ? 'si' : 'no', cascada: REF200 });
    vueltas = 0;
    ordenar();
  });

  /* ------------------------------------------- PIEZA PROPUESTA (26 oct, Ticket medio) */
  function datosPack(el) {
    return {
      producto: el.getAttribute('data-producto') || '',
      cantidad: parseInt(el.getAttribute('data-cant'), 10) || 1,
      meta: el.getAttribute('data-meta') || '',
      importe: (parseInt(el.getAttribute('data-importe'), 10) || 0) / 100
    };
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-bv-pack]') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    var datos = datosPack(b);
    var texto = b.textContent;
    b.disabled = true;
    b.textContent = 'Añadiendo…';
    pedir('/cart/add.js', {
      items: [{ id: parseInt(b.getAttribute('data-bv-pack'), 10), quantity: datos.cantidad, properties: { _origen: 'aviso:' + datos.meta } }]
    }).then(function (r) {
      medir('bv_pack_anadir', datos);
      return pedir('/cart.js').then(function (c) { c.sections = r.sections; avisar(c); });
    }).then(function () {
      vueltas = 0;
      ordenar(); /* pone o cambia la cascada que toque con el nuevo importe */
    }).catch(function () {
      b.textContent = 'Ahora mismo no se puede añadir';
      setTimeout(function () { b.disabled = false; b.textContent = texto; }, 3000);
    });
  });

  var packVistos = {}, packPendiente = false;
  function packsEnPantalla() {
    if (packPendiente) return;
    packPendiente = true;
    requestAnimationFrame(function () {
      packPendiente = false;
      if (!document.documentElement.classList.contains('bv-regalo-on')) return;
      var filas = document.querySelectorAll('[data-bv-pack-fila]');
      for (var i = 0; i < filas.length; i++) {
        if (!filas[i].getClientRects().length) continue; /* la cesta lateral está cerrada */
        var d = datosPack(filas[i]);
        var k = d.producto + ':' + d.cantidad + ':' + d.meta;
        if (packVistos[k]) continue;
        packVistos[k] = true;
        medir('bv_pack_ver', d);
      }
    });
  }
  function vigilarPacks() {
    packsEnPantalla();
    if ('MutationObserver' in window) {
      new MutationObserver(packsEnPantalla).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilarPacks);
  else vigilarPacks();

  /* Al entrar en cualquier página, solo si la cesta lleva algo de esto (lo dice Liquid en bossvi-global) */
  if (window.__bvRegaloEnCesta) ordenar();

  /* ---------------------------------------------------------------- FICHA */
  var vistos = {};
  function medidaActual() {
    var zona = document.querySelector('.product-details') || document;
    var form = zona.querySelector('product-form-component form, form[action*="/cart/add"]');
    var id = form ? form.querySelector('input[name="id"]') : null;
    return id ? String(id.value) : '';
  }
  var pendiente = false;
  function pintarFicha() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      if (!document.querySelector('[data-bv-regalo-ficha]')) return;
      var v = medidaActual();
      if (!v) return;
      var d = document.documentElement;
      if (d.getAttribute('data-bv-var') !== v) d.setAttribute('data-bv-var', v);
      if (REGALAN[v] && d.classList.contains('bv-regalo-on') && !vistos[v]) {
        vistos[v] = true;
        medir('bv_regalo_ver', { medida: REGALAN[v], cascada: REF });
      }
    });
  }

  function arrancar() {
    pintarFicha();
    document.addEventListener('variant:update', pintarFicha);
    document.addEventListener('change', function () { setTimeout(pintarFicha, 0); }, true);
    var zona = document.getElementById('MainContent');
    if (zona && 'MutationObserver' in window) {
      new MutationObserver(pintarFicha).observe(zona, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
